import { ContainerContext } from '../../containers';
import { BaseContainer, CommonHeaderProps } from '../common';
import * as React from 'react';
import { toLink } from '../../utils';
import { BuildOutlined as BuildIcon } from '@mui/icons-material';
import { PropsWithChildren } from 'react';

interface Props extends ContainerContext.Props, CommonHeaderProps, PropsWithChildren {
}

export class BaseCloudBuildContainer extends React.Component<Props> {
    render() {
        const { loading, headline, headlines, children, buttons } = this.props;
        const subTabsTitles = ['Build History', 'Config'];

        return (
            <BaseContainer
                {...this.props}
                title = {'Cloud Build'}
                TitleIcon={BuildIcon}
                headline = {headline}
                headlines = {headlines}
                subTabs={{
                    titles: subTabsTitles,
                    selected: this.subTabsSelected(),
                    onChange: this.changeSubTabs,
                }}
                buttons={buttons}
            >
                {children}
            </BaseContainer>
        );
    }

    private subTabsSelected = () => {
        if (location.pathname.includes(this.getPath('history'))) {
            return  0;
        } else if (location.pathname.includes(this.getPath('config'))) {
            return  1;
        }

        return 0;
    };

    private changeSubTabs = (tab: number) => {
        let to = '';
        switch (tab) {
            case 0:
                to = this.getPath('history');
                break;
            case 1:
                to = this.getPath('config');
                break;
        }
        toLink(this.props, to);
    };

    private getPath = (component: string) => {
        return `/cloudBuild/${component}`;
    };
}
